/**
 * useCalendarPreferences Hook
 *
 * Hook para gerenciar preferências de calendário do usuário
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { UserCalendarPreferences } from '@troia-v3/types';
import { calendarPreferencesService } from '../services/calendarPreferencesService';
import { toast } from 'sonner';

/**
 * Hook para buscar preferências de calendário do usuário
 */
export const useUserCalendarPreferences = () => {
  return useQuery({
    queryKey: ['user-calendar-preferences'],
    queryFn: () => calendarPreferencesService.getUserPreferences(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

/**
 * Hook para atualizar preferências de calendário do usuário
 */
export const useUpdateUserCalendarPreferences = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (preferences: UserCalendarPreferences) =>
      calendarPreferencesService.updateUserPreferences(preferences),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-calendar-preferences'] });
      toast.success('Preferências de disponibilidade atualizadas com sucesso!');
    },
    onError: (error: any) => {
      const message = error.response?.data?.message || 'Erro ao atualizar preferências';
      toast.error(message);
    },
  });
};
